import React, { memo, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../../../atoms/display/icon'
import Typography from '../../../atoms/display/typography'

import useStyles from './style'

import { ChatBubbleRounded as FAQIcon } from '@material-ui/icons'
import { removeSpecials } from '../../../../utils/customMethods'
import TooltipInfo from '../tooltipInfo'
import FaqsCategoryItem from './subs/FaqsCategoryItem'
import { useSelector } from 'react-redux'

const FaqsComponent = ({ keyword, ...props }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const activeConversation = useSelector((state) => state.activeConversation)
  const faqs = useSelector((state) => state.faq)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )

  const [triggerExpanded, setTriggerExpanded] = React.useState(false)

  const faqsContent = useMemo(() => {
    const faqsItems = faqs?.content || []

    if (keyword) {
      return (
        faqsItems?.filter((el) => {
          return (
            removeSpecials(el?.title)
              ?.toLowerCase()
              .includes(keyword.toLowerCase()) ||
            removeSpecials(el?.text)
              ?.toLowerCase()
              .includes(keyword.toLowerCase())
          )
        }) || []
      )
    }

    return faqsItems || []
  }, [faqs?.content, conversation?.skillId, keyword])

  const faqsCategory = useMemo(() => {
    const hasCategoryNull = faqsContent.some((item) => item.categories === null)
    const categories = faqsContent.flatMap((item) => item.categories || [])

    hasCategoryNull && categories.unshift(t('faqs.category.notfound'))

    return (
      [...new Set(categories)].sort(function (a, b) {
        if (
          a === t('faqs.category.notfound') ||
          b === t('faqs.category.notfound')
        ) {
          return 1
        }
        const textA = a.toUpperCase()
        const textB = b.toUpperCase()

        if (textA < textB) return -1

        if (textA > textB) return 1

        return 0
      }) || []
    )
  }, [faqsContent])

  useEffect(() => {
    if (keyword) {
      setTriggerExpanded(true)
    }
    return () => {
      setTriggerExpanded(false)
    }
  }, [keyword, faqsCategory])

  return (
    <>
      <div className={classes.titleContainer}>
        <Icon text={t('buttons.FAQ')}>
          <FAQIcon />
        </Icon>
        <TooltipInfo />
      </div>
      <div
        style={{
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        {!faqsCategory?.length && (
          <div style={{ textAlign: 'center', marginTop: '1em' }}>
            <Typography>{t('commons.searchResultEmpty')}</Typography>
          </div>
        )}

        {faqsCategory?.map((category, key) => {
          return (
            <FaqsCategoryItem
              key={key}
              category={category}
              faqsContent={faqsContent}
              triggerExpanded={triggerExpanded}
            />
          )
        })}
      </div>
    </>
  )
}

export default memo(FaqsComponent)
